<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M5.333 5.09c0-1.339 1.061-2.424 2.37-2.424h16.593c1.31 0 2.37 1.085 2.37 2.424v23.03c0 .46-.253.88-.655 1.085a1.164 1.164 0 01-1.241-.115L16 22.363 7.23 29.09c-.36.276-.84.32-1.242.115a1.215 1.215 0 01-.655-1.084V5.09z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsBookmarkFilled'
}
</script>
